import React, {ReactElement, useEffect, useRef, useState} from "react"
import "./BrandArchiveListItem.scss"
import {TextAndCarousel} from "../../ProductContent/contents/contentComponents";
import {useNavigate} from "react-router-dom";
import {SmallLinkRightArrowColorChagne} from "../../../../assets/Arrows";
import {convertMonthV2} from "../../../utils/utils";
import {breakpointDt, breakpointDt_mid} from "../../../constants/constants";

interface IProps {
    item: any
    useAutoMargin?: boolean
}

function BrandArchiveListItem(props: IProps) {
    const {item, useAutoMargin = true} = props
    const navigate = useNavigate()

    const descriptionRef = useRef(null)
    const brandArchiveItemRef = useRef(null);
    const [updateTime, setUpdateTime] = useState(new Date(item.register_date))
    useEffect(() => {
        listItemMarginByResize()
        window.addEventListener('resize', listItemMarginByResize)
        return () => window.removeEventListener('resize', listItemMarginByResize)
    }, [item])

    const listItemMarginByResize = () => {
        if (useAutoMargin) {
            const descriptionElement = descriptionRef.current as Element
            const brandArchiveItemElement = brandArchiveItemRef.current as HTMLElement
            if (window.innerWidth < breakpointDt_mid) {
                brandArchiveItemElement.setAttribute('style', `margin-bottom:${descriptionElement.clientHeight / 2 + 56}px`)
            } else if (breakpointDt_mid <= window.innerWidth && window.innerWidth < breakpointDt) {
                brandArchiveItemElement.setAttribute('style', `margin-bottom:28px`)
            } else if (window.innerWidth >= breakpointDt) {
                brandArchiveItemElement.setAttribute('style', `margin-bottom:8px`)

            }
        }
    }

    const convertDataByType = (item: any) => {
        switch (item.type) {
            case 'paragraph':
                return <div className={`brand-archive-${item.type}`}
                            dangerouslySetInnerHTML={{__html: item.data.text}}
                />
            case 'header':
                return <div className={`brand-archive-${item.type}`}
                            dangerouslySetInnerHTML={{__html: item.data.text}}
                />
        }
    }

    return (
        <div className="brand-archive-list-item" ref={brandArchiveItemRef} onClick={() => {
            navigate(`/makersnote/${item.slug}`)
        }}>
            <div className={"brand-archive-list-item-img"}>
                <img src={item.thumbnail_url} alt=""/>
            </div>
            <div className={"brand-archive-list-item-description-wrapper"} ref={descriptionRef}>
                <div className="brand-archive-list-item-description-title-wrapper">
                    <div className={"brand-archive-list-item-description-title"}>
                        {item.title}
                    </div>
                </div>
                <div className={"brand-archive-list-item-sub-info-wrapper"}>
                    <div className={"brand-archive-list-item-sub-info"}> {item.writer}
                        <div className="blank">|</div>
                        {convertMonthV2(updateTime.getMonth())} {updateTime.getDate()}, {updateTime.getFullYear()}</div>
                    <div className={"brand-archive-list-item-arrow-wrapper"}>
                        <img src={require("../../../../img/brandArchive/black_arrow.png")} className="a-img"/>
                        <img src={require("../../../../img/brandArchive/hover-img.png")} className="b-img"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BrandArchiveListItem
